//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React, { ReactElement } from 'react'
import { Typography } from '@mui/material'
import ViewItem from './ViewItem'

export default function ViewString(props: {
  value: string
  inTable: boolean
  label: string
  toolTip?: string
}): ReactElement {
  const { value, inTable, label, toolTip } = props

  if (inTable) {
    return (
      <React.Fragment>
        <Typography variant="bodyBold" gutterBottom component="div">
          {value}
        </Typography>
      </React.Fragment>
    )
  }
  return (
    <ViewItem toolTip={toolTip}>
      <Typography variant="bodyMuted" gutterBottom component="div">
        {label}
      </Typography>
      <Typography variant="bodyBold" gutterBottom component="div">
        {value}
      </Typography>
    </ViewItem>
  )
}
